export default __webpack_public_path__ + "static/media/a012-8.664a2062.svg";